(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/views/coupon/coupon.js') >= 0) return;  svs.modules.push('/modules/matchen/views/coupon/coupon.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.matchen=_svs.matchen||{};
_svs.matchen.templates=_svs.matchen.templates||{};
svs.matchen.templates.coupon = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "Rensa";
},"3":function(container,depth0,helpers,partials,data) {
    return "";
},"5":function(container,depth0,helpers,partials,data) {
    return "\n<div class=\"betslip-position-tag\"></div>\n<div id=\"betslip-wrapper\" class=\"region-betslip betslip-wrapper\"></div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  "<div class=\"region-coupon padding-left padding-right\"></div>\n  <div class=\"padding-1\">\n    "
    + ((stack1 = (lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||alias2).call(alias1,"button",{"name":"ui","hash":{"class":"qa-clear js-clear-btn","transparent":true,"size":100},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":3,"column":88}}})) != null ? stack1 : "")
    + "\n  </div>\n";
  stack1 = ((helper = (helper = lookupProperty(helpers,"isMobile") || (depth0 != null ? lookupProperty(depth0,"isMobile") : depth0)) != null ? helper : alias2),(options={"name":"isMobile","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":5,"column":0},"end":{"line":8,"column":13}}}),(typeof helper === "function" ? helper.call(alias1,options) : helper));
  if (!lookupProperty(helpers,"isMobile")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"useData":true});
Handlebars.partials['svs-matchen-coupon'] = svs.matchen.templates.coupon;
})(svs, Handlebars);


 })(window);